import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import MainLayout from './layouts/MainLayout';
import Dashboard from './components/dashboard/Dashboard';
import Login from './components/auth/Login';
import PrivateRoute from './components/PrivateRoute';
import ErrorLogs from './components/common/ErrorLogs';
import CoinsList from './components/coins/CoinsList';
import CoinConfig from './components/coins/CoinConfig';
import CoinUsers from './components/coinUsers/CoinUsers';
import CoinUserDetail from './components/coinUsers/CoinUserDetail';
import CoinTaskList from './components/coinTasks/CoinTaskList';
import CoinTaskDetail from './components/coinTasks/CoinTaskDetail';
function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {/* Protected Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<MainLayout><Dashboard /></MainLayout>} />
              <Route path="/dashboard" element={<MainLayout><Dashboard /></MainLayout>} />
              <Route path="/coins" element={<MainLayout><CoinsList /></MainLayout>} />
              <Route path="/coin-users" element={<MainLayout><CoinUsers /></MainLayout>} />
              <Route path="/coin-users/detail" element={<MainLayout><CoinUserDetail /></MainLayout>} />
              <Route path="/coin-config" element={<MainLayout><CoinConfig /></MainLayout>} />
              <Route path="/coin-tasks" element={<MainLayout><CoinTaskList /></MainLayout>} />
              <Route path="/coin-tasks/:taskId" element={<MainLayout><CoinTaskDetail /></MainLayout>} />
              <Route path="/logs" element={<MainLayout><ErrorLogs /></MainLayout>} />
            </Route>

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App; 